module.exports = __webpack_public_path__ + "img/crash.9cf3bd66.jpg";